import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config/config";
import {
  playMorseCodeAudio,
  stopMorseAudio,
} from "../../utils/practicePage/MorseCodeGenerator";
import { checkInputUtility } from "../../utils/checker/checkerInput";
import "../../styles/testPage/CheckerAudioPlayer.css";

const CheckerAudioPlayer = ({
  selectedLetters,
  checkerGroups,
  audioGroups,
  wpm,
  lessonId,
  userId,
  fromPracticePage,
}) => {
  const [userInput, setUserInput] = useState("");
  const [result, setResult] = useState(null);
  const [accuracy, setAccuracy] = useState(null);
  const [highlightedAnswer, setHighlightedAnswer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasPlayedOnce, setHasPlayedOnce] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const checkInput = () => {
    if (!hasPlayedOnce) return;

    // ✅ CALL UTILITY INSTEAD OF LOCAL LOGIC
    const { calculatedAccuracy, groupedHTML } =
      checkInputUtility(checkerGroups, userInput);

    setAccuracy(calculatedAccuracy);
    setResult(`Accuracy: ${calculatedAccuracy}%`);
    setHighlightedAnswer(groupedHTML);
    setChecked(true);

    if (!fromPracticePage) {
      if (userId) {
        updateUserProgress(calculatedAccuracy);
      } else {
        saveProgressLocally(calculatedAccuracy);
      }
    }

    const button = document.querySelector(".checkerButton");
    button.classList.add("active-effect");

    setTimeout(() => {
      button.classList.remove("active-effect");
    }, 1000);
  };

  const updateUserProgress = async (accuracy) => {
    try {
      await axios.post(`${config.API_URL}/api/lesson/update-user-progress`, {
        userId: userId,
        individualLessonId: lessonId,
        accuracy: parseFloat(accuracy),
        status: accuracy >= 90 ? "completed" : "in_progress",
      });
    } catch (error) {
      console.error("❌ Failed to update progress:", error);
    }
  };

  const saveProgressLocally = (accuracy) => {
    const progressData = {
      lesson_title: selectedLetters,
      sublesson_wpm: wpm,
      progress_percentage: parseFloat(accuracy),
      last_updated: new Date().toISOString(),
    };

    const existingData =
      JSON.parse(localStorage.getItem("cachedProgress")) || [];
    existingData.push(progressData);
    localStorage.setItem("cachedProgress", JSON.stringify(existingData));
  };

  const handlePlayAudio = () => {
    if (isPlaying) return;

    setIsPlaying(true);
    playMorseCodeAudio(audioGroups, wpm, () => {
      setIsPlaying(false);
      setHasPlayedOnce(true);
    });
  };

  const handleStartOver = () => {
    setUserInput("");
    setHighlightedAnswer(null);
    setChecked(false);
    setResult(null);
    setAccuracy(null);
    setHasPlayedOnce(false);
    stopMorseAudio();
  };

  useEffect(() => {
    return () => {
      stopMorseAudio();
    };
  }, []);

  return (
    <div>
      <div className="mt-4 title">{selectedLetters}</div>
      <div className="subTitle">{wpm} WPM</div>

      <div className="results">
        <span
          className={`result-text ${
            accuracy < 90 ? "resultFail" : "resultPass"
          }`}
        >
          {result}
        </span>
      </div>

      <div className="container mx-auto d-flex flex-column justify-content-center mt-5">
        {checked ? (
          <div className="highlightedAnswer">
            <div
              className="groupContainer"
              dangerouslySetInnerHTML={{ __html: highlightedAnswer }}
            />
          </div>
        ) : (
          <textarea
            className="checkerInput"
            value={userInput}
            onChange={handleInputChange}
            placeholder="|"
            rows={4}
            cols={50}
          />
        )}

        <div className="checkerContainer">
          <button
            className="testButton"
            onClick={handlePlayAudio}
            disabled={isPlaying}
          >
            Play Morse Code
          </button>

          <button
            className="testButton checkerButton"
            onClick={checkInput}
            disabled={checked || !hasPlayedOnce}
          >
            Check
          </button>
        </div>

        {checked && (
          <button className="mt-4 startOverButton" onClick={handleStartOver}>
            <img
              src="testpage-reload.png"
              alt="Start Over"
              className="startOverArrow"
            />
            Start Over
          </button>
        )}
      </div>
    </div>
  );
};

export default CheckerAudioPlayer;
